module.exports = __webpack_public_path__ + "img/typhoon_50_63.d6e03892.jpg";